import React from 'react';
import { HotDealTab as HotDealTab$1 } from './mobile/HotDealTab.es.js';
import { HotDealTab as HotDealTab$2 } from './desktop/HotDealTab.es.js';
import { useDevice } from '../../contexts/DeviceContext.es.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const HotDealTab = (props) => {
  const { isMobile } = useDevice();
  if (isMobile)
    return /* @__PURE__ */ React.createElement(HotDealTab$1, __spreadValues({}, props));
  return /* @__PURE__ */ React.createElement(HotDealTab$2, __spreadValues({}, props));
};

export { HotDealTab };
